import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { isNullOrEmpty } from "../Utils/TextUtils";
import { CustomError } from "./Toast";
import { useNavigate } from "react-router-dom";

const GenderPopupModel = ({setGenderPopupVisibilityPopup}) => {
  const { t, i18n } = useTranslation();
  const disableScrollOnOpen = () => {
    document.body.style.overflow = "hidden";
  };
  const disableScrollOnClose = () => {
    document.body.style.overflow = "auto";
  };

  const navigate = useNavigate()
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [gender, setGender] = useState();
  const [location, setLocation] = useState()
  const gendersArray = [
    {label: t("male"), value: 2},
    {label: t("female"), value: 1},
  ]

  const locationArray = [
    {label: t("east"), value: 3},
    {label: t("west"), value: 4},
  ]

  //#region localization code
  
  let [isArabic, setIsArabic] = useState(
    i18n.resolvedLanguage == "ar" ? true : false
  );
  useEffect(() => {
    if (i18n.resolvedLanguage == "en") {
      setIsArabic((isArabic = false));
    } else {
      setIsArabic((isArabic = true));
    }
  }, [i18n.resolvedLanguage]);
  //#endregion

  return (
    <>
      <Modal
        onAfterOpen={disableScrollOnOpen}
        onAfterClose={disableScrollOnClose}
        isOpen={isModalOpen}
        shouldCloseOnOverlayClick={false}
        onRequestClose={() => {setIsModalOpen(false)}}
        // style={customStyles}
        className="Branch_Modal"
        overlayClassName="Branch_Overlay"
      >
        <div className="Pop_Select_Branch_Text_Style" style={{marginBottom:0}}>
          {t("slct_gndr")}
        </div>
        <div className="gender__desc">{t('gender_desc')}</div>
        <Select
              placeholder={t("slct_gndr")}
              options={gendersArray}
              className="gender_Select_Option_Style"
              classNamePrefix="Select"
              onChange={(event) => {
                setGender(event);
                localStorage.setItem("type", event.value == 2 ? event.value : "")
              }}
              value={gender}
              components={{
                IndicatorSeparator: () => null,
              }}
              isSearchable={false}
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  // borderColor: state.isFocused ? "white" : null,
                  borderRadius: "10px",
                  border: state.isFocused ? 0 : 0,
                  outline: state.isFocused ? "none" : "none",
                  boxShadow: "none",
                  cursor: "pointer",
                }),
              }}
        />
        {
          gender?.value == 1 &&
          <>
          <div className="Pop_Select_Branch_Text_Style">
            {t("slct_lction")}
          </div>
             <Select
              placeholder={t("slct_lction")}
              options={locationArray}
              className="gender_Select_Option_Style"
              classNamePrefix="Select"
              onChange={(event) => {
                setLocation(event);
                localStorage.setItem("type", event.value)
              }}
              value={location}
              components={{
                IndicatorSeparator: () => null,
              }}
              isSearchable={false}
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  // borderColor: state.isFocused ? "white" : null,
                  borderRadius: "10px",
                  border: state.isFocused ? 0 : 0,
                  outline: state.isFocused ? "none" : "none",
                  boxShadow: "none",
                  cursor: "pointer",
                }),
              }}
            />
          </>
        }
        <div style={{display:"flex", justifyContent:"center"}}>
          <button className="continue__btn" onClick={()=>{
            if(isNullOrEmpty(gender))
            CustomError(t("slct_gndr"));
            else if(gender?.value == 1 && isNullOrEmpty(location))
            CustomError(t("slct_lction"))
            else navigate('/home')
          }} >{t("cntnue")}</button>
        </div>
      </Modal>
    </>
  );
};

export default GenderPopupModel;
